import React from "react";
import { useStoreState } from 'easy-peasy';
import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';

const CategoryFormComponent = ({ category = null }) => {
    const { apiData: { ACTIONS } } = useStoreState(state => state.actionSlugs);
    const token = ACTIONS.categories[category ? 'update' : 'create'].csrfToken;

    return (
        <div>
            <div>
                <Form id="category-form">
                    <Form.Group>
                        <Form.Label>Nom :</Form.Label>
                        <Form.Control
                            type="text"
                            name="name"
                            defaultValue={category?.name ?? ""}
                        />
                        <Form.Control.Feedback type='invalid' name='feedback-name'></Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group >
                        <Form.Control
                            name="csrfToken"
                            defaultValue={token}
                            type="hidden"
                        />
                    </Form.Group>
                </Form>
            </div>
        </div>

    );
};

export const submitCategoryForm = ({ category, allCategories, action }) => {
    let error = false;

    let formData = new FormData(document.getElementById('category-form'));

    let name = formData.get('name');

    document.getElementsByName('name')[0].classList.remove("is-invalid");

    if (name === "") {
        document.getElementsByName('name')[0].classList.add("is-invalid");
        document.getElementsByName(`feedback-name`)[0].innerHTML = "Le nom de catégorie est obligatoire";
        error = true;
    }
    if (name && allCategories.find(cat => cat.name.toLowerCase() === name.toLowerCase() && cat.uniqueId !== category?.uniqueId)) {
        document.getElementsByName('name')[0].classList.add("is-invalid");
        document.getElementsByName(`feedback-name`)[0].innerHTML = "Ce nom de catégorie existe déjà";
        error = true;
    }

    if (error) {
        return Promise.reject(new Error());
    } else {
        let data = { name: formData.get('name'), csrfToken: formData.get('csrfToken') }

        if (category) {
            data = { data: data, uniqueId: category.uniqueId }
        } else {
            const valueFromName = data.name.toLowerCase()
                ?.split(' ')
                ?.map(word => word.charAt(0).toUpperCase() + word.slice(1))
                ?.join('');
            data.value = valueFromName;
        }

        return action(data)
            .catch(() => {
                return Promise.reject(new Error());
            })
    }
}

CategoryFormComponent.propTypes = {
    category: PropTypes.object
};
export default CategoryFormComponent;